import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';


export function RouteEffects() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, needsOnboarding } = useAuth();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!user || !needsOnboarding) return;
    const allowed = ['/onboarding', '/activate-account', '/login'];
    if (!allowed.some((path) => location.pathname.startsWith(path))) {
      navigate('/onboarding', { replace: true });
    }
  }, [user, needsOnboarding, location.pathname, navigate]);

  return null;
}